// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"3717c0bd","277":"abae064c","279":"8a6f0967","628":"5e352e4a","772":"dfbe3e55","853":"417541ff"}[chunkId] + ".chunk.js";
};